module.exports = __webpack_public_path__ + "d95e0efdefa8fa0fb355209dc0bfbeb9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-13.png
// module id = 2933
// module chunks = 0